module.exports = __webpack_public_path__ + "img/withdraw-tree-img.3b323406.png";